import {Component, EventEmitter, Input, OnInit, Output, signal} from '@angular/core';
import {Observable} from 'rxjs';
import {first} from 'rxjs/operators';
import {DealerService} from '../../service/dealer.service';
import {OfferService} from '../../service/offer.service';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead/typeahead-match.class';
import {toObservable} from '@angular/core/rxjs-interop';
import {TranslateService} from '@ngx-translate/core';
import {ucsDeepCopy} from '../../misc/utils';

/**
 */
@Component({
  selector: 'ucs-dealer-autocomplete',
  templateUrl: './dealer-autocomplete.component.html',
  styleUrls: ['./dealer-autocomplete.component.scss'],
  standalone: false
})
export class DealerAutocompleteComponent implements OnInit{
  @Input() sourceFunction: (string) => Observable<DealerDetailDto[]>;
  @Input() channel: DistributionChannel;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() sidebar: boolean;
  @Input() smallerHeading: boolean;
  @Input() class: string;
  @Input() clearOnSelect = true;
  @Input() showCompanyNumberOrPbvCustomerNumber = true;
  @Input() offerId: number;
  @Output() onSelected = new EventEmitter<any>();
  @Output() onBlur = new EventEmitter<void>();
  showBiddingDealers = true;
  bidDataSource: OnBehalfDealerDetailDto[];
  selectedValue = '';
  typeaheadData = signal([]);
  typeaheadData$ = toObservable(this.typeaheadData);
  tempPlaceholder = '';

  /**
   * Bind our async datasource to the observable returned by the source function
   */
  constructor(protected dealerService: DealerService, private offerService: OfferService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    if(this.offerId) {
      this.offerService.getBiddingUserAndDealers(this.offerId)
        .pipe()
        .subscribe(biddingDealer => {
          this.bidDataSource = biddingDealer;
          this.typeaheadData.set(biddingDealer);
        });
    }
  }

  /**
   * Emit the selected item to the parent
   */
  onSelect(event: TypeaheadMatch): void {
    this.onSelected.emit(event.item);
    if (this.clearOnSelect) {
      this.selectedValue = '';
    }
  }

  onFocus() {
    if(this.offerId && this.bidDataSource?.length > 0) {
      this.tempPlaceholder = ucsDeepCopy(this.placeholder);
      this.placeholder = this.translateService.instant('offer-maintenance.detail.bids.bidder.premade');
    }
    this.onInput();
  }

  blur() {
    if(this.offerId && this.bidDataSource?.length > 0) {
      this.placeholder = this.tempPlaceholder;
    }
    this.onBlur.emit();
  }

  onInput() {
    if (this.selectedValue === '' || this.selectedValue === undefined) {
      this.selectedValue = '' ;
      this.showBiddingDealers = true;
      this.typeaheadData.set(this.bidDataSource);
    } else if(this.selectedValue.length > 2) {
      this.showBiddingDealers = false;
      this.sourceFunction(this.selectedValue)
        .pipe(first())
        .subscribe(dealer => {
          this.typeaheadData.set(dealer);
        });
    } else {
      this.typeaheadData.set([]);
    }
  }

  /**
   * Allows overriding the current selection (intended to be used by parent component)
   */
  overrideSelection(companyNumberOrPbvCustomerNumber: string, name: string) {
    if (companyNumberOrPbvCustomerNumber === undefined && name === undefined) {
      this.selectedValue = undefined;
    } else { // or set the selected value if not undefined
      this.selectedValue = companyNumberOrPbvCustomerNumber + ' ' + name;
    }
  }
}
